var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bgblack"}},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content",attrs:{"id":"content"}},[_c('router-view')],1)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }